module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1033-995c67dae5a1c50fd893377fd2d51367.png";